import { useTranslate } from '@dreryk/react-common';

import { translationKeys } from '../translations';

import { StyledPartialPreviewBox } from './PartialPreview.styled';

type PartialPreviewProps = {
   text: string;
};

export const PartialPreview = (props: PartialPreviewProps): JSX.Element => {
   const translate = useTranslate();

   return (
      <StyledPartialPreviewBox>
         {props.text || translate(translationKeys.dictationMode.listeningPlaceholder)}
      </StyledPartialPreviewBox>
   );
};
